module.exports = __webpack_public_path__ + "media/step2_animation_Brueche.7b61760d.webm";